"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTEXT_CHANGE_ASSIGNMENTS = 'CONTEXT_CHANGE_ASSIGNMENTS';
exports.CONTEXT_CHANGE_PATH_WILDCARD = '*';
function onContextChange(contextName, path) {
    return function (target, propertyKey) {
        if (!target[exports.CONTEXT_CHANGE_ASSIGNMENTS]) {
            target[exports.CONTEXT_CHANGE_ASSIGNMENTS] = {};
        }
        target[exports.CONTEXT_CHANGE_ASSIGNMENTS][contextName] = {
            methodName: propertyKey,
            path: path ? path : exports.CONTEXT_CHANGE_PATH_WILDCARD
        };
    };
}
exports.onContextChange = onContextChange;
//# sourceMappingURL=on-context-change.js.map